import React from 'react';
import classNames from 'classnames/bind';
import { Text } from '@carnica/ui-kit';
import { Metric } from "../../../../../../../../metric";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var SecondaryBlock = function SecondaryBlock(_ref) {
  var links = _ref.links;
  return /*#__PURE__*/React.createElement("nav", {
    className: cx('secondary-block'),
    "data-t-id": "components-SecondaryBlock"
  }, links.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Metric, {
      asChild: true,
      data: item.title.toLowerCase(),
      events: {
        headerMetric: ['handleNavLinkClick']
      },
      key: index,
      mode: "click"
    }, /*#__PURE__*/React.createElement(Text, {
      className: cx('item'),
      color: "tertiary-invert",
      href: item.href
      /* TODO: Поправить */
      /* eslint-disable-next-line react/no-array-index-key */,
      size: "xs",
      tagName: "a",
      "data-t-id": "components-SecondaryBlock"
    }, item.title.toLowerCase()));
  }));
};